import React from 'react';
import { Bar } from 'react-chartjs-2';
import styles from './CustomBarChart.module.css';
import { ChartOptions } from 'chart.js';
import "chart.js/auto";

export interface BarChartInterface{
    xItems: any[],
    yItems: any[],
    title: string,
    rgba: string,
    isVertical?: boolean,
}

function CustomBarChart({xItems, yItems, title, rgba, isVertical = true}: BarChartInterface){
    const data = {
        labels: xItems,
        datasets: [
          {
            label: title,
            backgroundColor: rgba,
            data: yItems,
          },
        ],
    };

    const options: ChartOptions<'bar'> = {
        indexAxis: isVertical ? 'x' : 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            // position: 'top',
          },
          title: {
            display: true,
            text: title,
          },
        },
    };

    return (
        <div className={styles['container']}>
            <Bar data={data} options={options}/>
        </div>
    );
}

export default CustomBarChart